import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { callAPI, showErrorNotification } from '../../shared/helpers';
import { FaIcon } from '../../shared/components';
import CutLineConfirmationModal from './cut_line_confirmation_modal';
import { componentText } from '../utils/i18n_utils';

const t = (key, fallback) => componentText(`cut_line_button.${key}`, fallback);

const checkFailedMessage = () => t('check_failed', 'The cut line could not be updated. Please try again.');

// Clicking asks the backend (show_hide_cut_line_button.json) whether the
// toggle needs manager confirmation at that moment: a `redirect_url` response
// navigates straight to cut_list_operations (which toggles and rescores),
// while a `confirmation` response opens the modal, whose confirm link
// navigates to the `confirm_url` the backend picked.
const CutLineButton = ({ button }) => {
  const [confirmation, setConfirmation] = useState(null);
  const [checking, setChecking] = useState(false);

  if (!button) return null;

  const handleClick = () => {
    if (checking) return;
    setChecking(true);

    callAPI(button.checkUrl, 'GET')
      .then((data) => {
        if (data.redirect_url) {
          window.location.href = data.redirect_url;
          return;
        }
        setChecking(false);
        if (data.confirmation) setConfirmation(data);
      })
      .catch(() => {
        setChecking(false);
        showErrorNotification(checkFailedMessage());
      });
  };

  return (
    <>
      <button className="lbv2__cut-line-btn" onClick={handleClick} disabled={checking}>
        <FaIcon icon={button.shown ? 'eye-slash-o' : 'eye-o'} />
        <span>
          {button.shown ? t('hide', 'Hide cut line') : t('show', 'Show cut line')}
        </span>
      </button>
      {confirmation && (
        <CutLineConfirmationModal
          button={{
            confirmation: confirmation.confirmation,
            confirmHref: confirmation.confirm_url,
            scorePercentage: confirmation.score_percentage,
            calculatedPercentage: confirmation.calculated_percentage,
          }}
          onClose={() => setConfirmation(null)}
        />
      )}
    </>
  );
};

CutLineButton.propTypes = {
  button: PropTypes.shape({
    shown: PropTypes.bool,
    checkUrl: PropTypes.string.isRequired,
  }),
};

export default CutLineButton;
